import React from 'react';
import { Switch, Route } from 'react-router-dom';
import styled from 'styled-components';
import { withQuery } from '@panel/commons/core/themev2';
import { StatusSuccess } from './StatusSuccess';
import { StatusFailed } from './StatusFailed';

const Container = styled.div`
  white-space: normal;
  font-family: 'Hind';
  ${withQuery.lg.down()} {
    height: 100vh;
    display: block;
  }
`;

const ModuleContainer = styled.div`
  flex: 0 1 80%;
  max-width: 1300px;
  width: 100%;
  margin: 0 auto;
  ${withQuery.lg.up()} {
    padding-top: 100px;
  }
  ${withQuery.lg.down()} {
    padding: 100px 0px 20px;
    text-align: center;
  }
`;

function PublishStatusContainer() {
  return (
    <Container>
      <ModuleContainer data-repa='publishStatus-container'>
        <Switch>
          <Route path='/publicador/status/success'>
            <StatusSuccess />
          </Route>
          <Route path='/publicador/status/failed'>
            <StatusFailed />
          </Route>
        </Switch>
      </ModuleContainer>
    </Container>
  );
}

export default PublishStatusContainer;
